import React, { Component } from 'react';
import { isValidForm } from '../../../utils/validation/CommonValidator';
import ButtonGrp from '../../../components/UIComponent/Buttons/ButtonGrp';
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import SwalServices from '../../../services/swalServices/SwalServices';
import { CommonValidationMessages } from '../../../utils/Messages';
import HodPermissionPopup from './HodPermissionTable';
import UserServices from '../../../services/axiosServices/apiServices/UserServices';
import AuthenticationServices from '../../../services/axiosServices/apiServices/AuthenticationServices';
import { getAuthProps } from '../../../utils/AuthenticationLibrary';

export default class HodPermissions extends Component {
    constructor(props) {
        super(props)
        this.userServices = new UserServices();
        this.authServices = new AuthenticationServices();
        this.SwalServices = new SwalServices();

        this.state = {
            showPassword: false,
            isModalOpen: false,
            rowData: [],
            roles: [],
            isUpdate: false,
            selectedId: 0,
            idUser: 0,
            idCompany: 0,
            colDefs: [
                {
                    headerName: "Name",
                    field: "personName",
                    flex: 2,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    headerName: "Username",
                    field: "username",
                    flex: 1,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    headerName: "Allow Login",
                    field: "allowLogin",
                    flex: 0.6,
                    filter: true,
                    floatingFilter: true,
                    cellRenderer: (params) => params.value ? "Yes" : "No"
                },
            ],
            paginationPageSize: 50,
            rowHeight: 40,

            permissionObject: {
                personName: "",
                userName: "",
                password: "",
                allowLogin: false,
                roleId: 0,
            },

            validState: {
                isValid: true,
                error: {},
            },

            validationRules: {
                personName: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace("{0}", "person name"),
                    }
                ],
                userName: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace("{0}", "username"),
                    }
                ],
                password: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace("{0}", "password"),
                    }
                ],
                roleId: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace("{0}", "role"),
                    }
                ],
            },
        }
    }

    componentDidMount() {
        let prop = getAuthProps()
        if (prop.idCompany && prop.idCompany > 0) {
            this.setState({ idCompany: prop.idCompany, idUser: prop.idUser }, () => {
                this.procSelectAll_HODLogin();
                this.getRoles();
            });
        }
    }

    procSelectAll_HODLogin = () => {
        this.userServices.procSelectAll_HODLogin(this.state.idCompany).then((response) => {
            if (response?.statusCode === 200 && response?.responseItem !== null) {
                this.setState({
                    rowData: response.responseItem.responseContent
                });

                if (this.gridApi) this.gridApi.hideOverlay();
            }
        });
    };

    getRoles = () => {
        this.authServices.getRoles().then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                const list = response.responseItem.responseContent;
                if (list?.length > 0) {
                    const userRoles = list
                        .filter(x => x.roleCategoryId === 2)
                        .map(x => ({
                            label: x.roleName,
                            value: x.roleId
                        }));

                    this.setState({
                        roles: userRoles,
                    });
                }
            }
        });
    };

    openPopUpForAddingItem = () => {
        this.resetDetailsFields();
        this.setState({
            isModalOpen: true,
            isUpdate: false,
            selectedId: 0
        });
    };

    onRowDoubleClicked = (event) => {
        const data = event.data;

        let permissionObject = {
            personName: data.personName,
            userName: data.username,
            password: data.password,
            allowLogin: data.allowLogin,
            roleId: data.roleId
        };

        this.setState({
            permissionObject,
            isModalOpen: true,
            isUpdate: true,
            selectedId: data.idHod,
            validState: { isValid: true, error: {} }
        });
    };

    isValidAllFields = () => {
        const newValidState = isValidForm(
            this.state.permissionObject,
            this.state.validationRules,
            this.state.validState,
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    };

    submit = () => {
        if (!this.isValidAllFields()) return;

        let req = {
            idHod: this.state.selectedId,
            personName: this.state.permissionObject.personName,
            username: this.state.permissionObject.userName,
            password: this.state.permissionObject.password,
            allowLogin: this.state.permissionObject.allowLogin,
            roleId: this.state.permissionObject.roleId,
            idCompany: this.state.idCompany
        };

        this.userServices.procInsertUpdate_HODLogin(req).then((res) => {
            if (res?.statusCode === 200) {
                if (res?.responseItem?.responseContent[0]?.messageType === "Exists") {
                    this.SwalServices.Error(res?.responseItem?.responseContent[0]?.message);
                } else {
                    this.SwalServices.Success(res?.responseItem?.responseContent[0]?.message);
                    this.procSelectAll_HODLogin();
                    this.setState({ isModalOpen: false });
                }
            }
        });
    };

    handleDelete = () => {
        const selected = this.state.selectedId;
        if (selected <= 0) {
            this.SwalServices.Error("Please select a record to delete.");
            return;
        }

        this.userServices.procDelete_HODLogin(selected).then((res) => {
            if (res?.statusCode === 200) {
                if (res?.responseItem?.responseContent[0]) {
                    this.SwalServices.Success(res?.responseItem?.responseContent[0]?.message);
                    this.setState({ isModalOpen: false }, () => {
                        this.procSelectAll_HODLogin();
                    });
                }
            }
        });
    };

    handleChange = (event, name) => {
        let value = event.target.value;
        let details = this.state.permissionObject;
        details[name] = value;
        this.setState({ permissionObject: details });
    };

    handleChangeFroDropdown = (event, name) => {
        let details = this.state.permissionObject;
        details[name] = event.value;
        this.setState({ permissionObject: details });
    };

    handleToggle = (event, name) => {
        let details = this.state.permissionObject;
        details[name] = event.target.checked;
        this.setState({ permissionObject: details });
    };

    togglePassword = () => {
        this.setState({ showPassword: !this.state.showPassword });
    };

    setOpenModel = () => {
        this.setState({ isModalOpen: !this.state.isModalOpen });
    };

    closePopup = () => {
        this.setState({ isModalOpen: false });
    };

    resetDetailsFields = () => {
        this.setState({
            permissionObject: {
                personName: "",
                username: "",
                password: "",
                allowLogin: false,
                roleId: 0
            },
            validState: { isValid: true, error: {} },
        });
    };

    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridApi.showLoadingOverlay();
    };

    render() {
        return (
            <div className='company-master'>
                <div className='data-display'>
                    <div className='data-display-inner relative'>

                        <ButtonGrp buttons={['add', 'print', 'delete']}
                            onClickHandlers={{
                                add: () => this.openPopUpForAddingItem(),
                                print: this.handlePrint,
                            }}
                        />

                        <HodPermissionPopup
                            isModalOpen={this.state.isModalOpen}
                            setOpenModel={this.setOpenModel.bind(this)}
                            permissionObject={this.state.permissionObject}
                            handleChange={this.handleChange.bind(this)}
                            close={this.closePopup.bind(this)}
                            handleChangeFroDropdown={this.handleChangeFroDropdown.bind(this)}
                            handleToggle={this.handleToggle.bind(this)}
                            validState={this.state.validState}
                            showPassword={this.state.showPassword}
                            togglePassword={this.togglePassword.bind(this)}
                            roles={this.state.roles}
                            submit={this.submit.bind(this)}
                            delete={this.handleDelete.bind(this)}
                            selectedId={this.state.selectedId}
                        />

                        <div className="table cursor-default w-full bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                            <div className="table-1 w-full px-[1px] rounded-[5px]" style={{ height: "calc(100vh - 156px)" }}>
                                <div className="table-inner">
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">HOD</h1>
                                </div>

                                <AgGridReact
                                    rowData={this.state.rowData}
                                    rowHeight={this.state.rowHeight}
                                    columnDefs={this.state.colDefs}
                                    pagination={true}
                                    paginationPageSize={this.state.paginationPageSize}
                                    onRowDoubleClicked={this.onRowDoubleClicked}
                                    onGridReady={this.onGridReady}
                                    overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                                    overlayNoRowsTemplate="<span>No Rows To Show</span>"
                                />
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        )
    }
}